module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"You have not participated in any GIP lunches yet":"You have not participated in any GIP lunches yet"},"ja":{"You have not participated in any GIP lunches yet":"まだGIPランチ参加していません"}}')
  delete Component.options._Ctor
}
